import { Camera } from "@capacitor/camera";
import { isNativeCapacitorApp } from "@/integrations/clients/carAuction/nativeAuth";

async function webPathToFile(
  webPath: string,
  fileName: string,
): Promise<File> {
  const res = await fetch(webPath);
  const blob = await res.blob();
  const mime = blob.type || "image/jpeg";
  return new File([blob], fileName, { type: mime });
}

/** Native camera capture via Capacitor (avoids WebView gallery-only file input). */
export async function pickNativeCameraPhoto(
  fileName = `photo-${Date.now()}.jpg`,
): Promise<File | null> {
  if (!isNativeCapacitorApp()) return null;

  const result = await Camera.takePhoto({ quality: 90 });
  if (!result.webPath) return null;
  return webPathToFile(result.webPath, fileName);
}

/** Native gallery pick via Android Photo Picker / iOS PHPicker (no READ_MEDIA_IMAGES). */
export async function pickNativeGalleryPhoto(
  fileName = `photo-${Date.now()}.jpg`,
): Promise<File | null> {
  if (!isNativeCapacitorApp()) return null;

  const { results } = await Camera.chooseFromGallery({ quality: 90 });
  const photo = results[0];
  if (!photo?.webPath) return null;
  return webPathToFile(photo.webPath, fileName);
}
